// extracted by mini-css-extract-plugin
export default {"steps":"CentifySteps_steps__4ScCh","step_text":"CentifySteps_step_text__A9FAG","steps_item":"CentifySteps_steps_item__d8OWk"};